import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AuthCredentials } from '../../models/auth.model';
import { User } from '../../models/user.model';
import { AllBuyerSettings, CompanySettings } from '../../models/settings.model';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    // Login
    Login: props<AuthCredentials>(),
    'Login Success': props<{ user: User }>(),
    'Login Failure': props<{ error: string }>(),
    // Logout
    Logout: emptyProps(),
    'Logout Success': emptyProps(),
    'Logout Failure': props<{ error: string }>(),
  },
});

export const SettingsActions = createActionGroup({
  source: 'Settings',
  events: {
    'Load Settings': emptyProps(),
    'Load Settings Success': props<{
      allBuyerSettings: AllBuyerSettings;
      companySettings: CompanySettings;
    }>(),
    'Load Settings Failure': props<{ error: string }>(),
  },
});
